import * as React from 'react'

import styled from '@emotion/styled'

import { LoadingIcon } from '@cash-design-system/react'

const ContentCentered = styled.div<{ height?: string }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${({ height }) => height && `height: ${height};`}
  align-items: center;
  justify-content: center;
  padding: 8rem 0;
`

export function BlockerLoading({ onEndFlow, height }: { onEndFlow?: () => void; height?: string }) {
  React.useEffect(() => {
    // we shouldn't wait an abritrary amount of time before calling end flow
    // let's call it immediately to speed up the process.
    onEndFlow?.()
  }, [onEndFlow])

  return (
    <ContentCentered height={height}>
      <LoadingIcon />
    </ContentCentered>
  )
}
